export const PHONE_NUMBER_LENGTHS = [
  {
    countryCode: 'AU',
    countryName: 'Australia',
    maxLength: 15,
    minLength: 4,
  },
  {
    countryCode: 'DE',
    countryName: 'Germany',
    maxLength: 13,
    minLength: 6,
  },
  {
    countryCode: 'SE',
    countryName: 'Sweden',
    maxLength: 13,
    minLength: 7,
  },
  {
    countryCode: 'AT',
    countryName: 'Austria',
    maxLength: 13,
    minLength: 4,
  },
  {
    countryCode: 'CN',
    countryName: 'China',
    maxLength: 12,
    minLength: 5,
  },
  {
    countryCode: 'CZ',
    countryName: 'Czechia',
    maxLength: 12,
    minLength: 4,
  },
  {
    countryCode: 'CH',
    countryName: 'Switzerland',
    maxLength: 12,
    minLength: 4,
  },
  {
    countryCode: 'RS',
    countryName: 'Serbia',
    maxLength: 12,
    minLength: 4,
  },
  {
    countryCode: 'SG',
    countryName: 'Singapore',
    maxLength: 12,
    minLength: 8,
  },
  {
    countryCode: 'FI',
    countryName: 'Finland',
    maxLength: 12,
    minLength: 5,
  },
  {
    countryCode: 'HR',
    countryName: 'Croatia',
    maxLength: 12,
    minLength: 8,
  },
  {
    countryCode: 'ME',
    countryName: 'Montenegro',
    maxLength: 12,
    minLength: 4,
  },
  {
    countryCode: 'PK',
    countryName: 'Pakistan',
    maxLength: 11,
    minLength: 8,
  },
  {
    countryCode: 'IT',
    countryName: 'Italy',
    maxLength: 11,
    minLength: 6,
  },
  {
    countryCode: 'KR',
    countryName: 'South Korea',
    maxLength: 11,
    minLength: 8,
  },
  {
    countryCode: 'PE',
    countryName: 'Peru',
    maxLength: 11,
    minLength: 8,
  },
  {
    countryCode: 'PG',
    countryName: 'Papua New Guinea',
    maxLength: 11,
    minLength: 4,
  },
  {
    countryCode: 'PT',
    countryName: 'Portugal',
    maxLength: 11,
    minLength: 9,
  },
  {
    countryCode: 'SV',
    countryName: 'El Salvador',
    maxLength: 11,
    minLength: 7,
  },
  {
    countryCode: 'IE',
    countryName: 'Ireland',
    maxLength: 11,
    minLength: 7,
  },
  {
    countryCode: 'UY',
    countryName: 'Uruguay',
    maxLength: 11,
    minLength: 4,
  },
  {
    countryCode: 'CY',
    countryName: 'Cyprus',
    maxLength: 11,
    minLength: 8,
  },
  {
    countryCode: 'LU',
    countryName: 'Luxembourg',
    maxLength: 11,
    minLength: 4,
  },
  {
    countryCode: 'VA',
    countryName: 'Vatican City',
    maxLength: 11,
    minLength: 10,
  },
  {
    countryCode: 'IN',
    countryName: 'India',
    maxLength: 10,
    minLength: 7,
  },
  {
    countryCode: 'US',
    countryName: 'United States',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'ID',
    countryName: 'Indonesia',
    maxLength: 10,
    minLength: 5,
  },
  {
    countryCode: 'NG',
    countryName: 'Nigeria',
    maxLength: 10,
    minLength: 7,
  },
  {
    countryCode: 'BR',
    countryName: 'Brazil',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'BD',
    countryName: 'Bangladesh',
    maxLength: 10,
    minLength: 6,
  },
  {
    countryCode: 'RU',
    countryName: 'Russia',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'MX',
    countryName: 'Mexico',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'JP',
    countryName: 'Japan',
    maxLength: 10,
    minLength: 9,
  },
  {
    countryCode: 'PH',
    countryName: 'Philippines',
    maxLength: 10,
    minLength: 8,
  },
  {
    countryCode: 'VN',
    countryName: 'Vietnam',
    maxLength: 10,
    minLength: 7,
  },
  {
    countryCode: 'IR',
    countryName: 'Iran',
    maxLength: 10,
    minLength: 6,
  },
  {
    countryCode: 'TR',
    countryName: 'Turkey',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'GB',
    countryName: 'United Kingdom',
    maxLength: 10,
    minLength: 7,
  },
  {
    countryCode: 'KE',
    countryName: 'Kenya',
    maxLength: 10,
    minLength: 6,
  },
  {
    countryCode: 'CO',
    countryName: 'Colombia',
    maxLength: 10,
    minLength: 8,
  },
  {
    countryCode: 'IQ',
    countryName: 'Iraq',
    maxLength: 10,
    minLength: 8,
  },
  {
    countryCode: 'AR',
    countryName: 'Argentina',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'CA',
    countryName: 'Canada',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'MG',
    countryName: 'Madagascar',
    maxLength: 10,
    minLength: 9,
  },
  {
    countryCode: 'VE',
    countryName: 'Venezuela',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'KP',
    countryName: 'North Korea',
    maxLength: 10,
    minLength: 3,
  },
  {
    countryCode: 'SY',
    countryName: 'Syria',
    maxLength: 10,
    minLength: 8,
  },
  {
    countryCode: 'KZ',
    countryName: 'Kazakhstan',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'DO',
    countryName: 'Dominican Republic',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'GR',
    countryName: 'Greece',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'BY',
    countryName: 'Belarus',
    maxLength: 10,
    minLength: 9,
  },
  {
    countryCode: 'NZ',
    countryName: 'New Zealand',
    maxLength: 10,
    minLength: 3,
  },
  {
    countryCode: 'PR',
    countryName: 'Puerto Rico',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'QA',
    countryName: 'Qatar',
    maxLength: 10,
    minLength: 6,
  },
  {
    countryCode: 'NA',
    countryName: 'Namibia',
    maxLength: 10,
    minLength: 6,
  },
  {
    countryCode: 'JM',
    countryName: 'Jamaica',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'TT',
    countryName: 'Trinidad and Tobago',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'EE',
    countryName: 'Estonia',
    maxLength: 10,
    minLength: 7,
  },
  {
    countryCode: 'BS',
    countryName: 'Bahamas',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'BB',
    countryName: 'Barbados',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'LC',
    countryName: 'Saint Lucia',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'GU',
    countryName: 'Guam',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'GD',
    countryName: 'Grenada',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'VC',
    countryName: 'Saint Vincent and the Grenadines',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'AG',
    countryName: 'Antigua and Barbuda',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'VI',
    countryName: 'United States Virgin Islands',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'KY',
    countryName: 'Cayman Islands',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'DM',
    countryName: 'Dominica',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'BM',
    countryName: 'Bermuda',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'TC',
    countryName: 'Turks and Caicos Islands',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'KN',
    countryName: 'Saint Kitts and Nevis',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'AS',
    countryName: 'American Samoa',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'SX',
    countryName: 'Sint Maarten',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'VG',
    countryName: 'British Virgin Islands',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'SM',
    countryName: 'San Marino',
    maxLength: 10,
    minLength: 6,
  },
  {
    countryCode: 'AI',
    countryName: 'Anguilla',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'MS',
    countryName: 'Montserrat',
    maxLength: 10,
    minLength: 10,
  },
  {
    countryCode: 'ET',
    countryName: 'Ethiopia',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'EG',
    countryName: 'Egypt',
    maxLength: 10,
    minLength: 7,
  },
  {
    countryCode: 'CD',
    countryName: 'DR Congo',
    maxLength: 9,
    minLength: 5,
  },
  {
    countryCode: 'TZ',
    countryName: 'Tanzania',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'TH',
    countryName: 'Thailand',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'FR',
    countryName: 'France',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'ZA',
    countryName: 'South Africa',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'MM',
    countryName: 'Myanmar',
    maxLength: 9,
    minLength: 7,
  },
  {
    countryCode: 'SD',
    countryName: 'Sudan',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'UG',
    countryName: 'Uganda',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'DZ',
    countryName: 'Algeria',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'ES',
    countryName: 'Spain',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'AF',
    countryName: 'Afghanistan',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'YE',
    countryName: 'Yemen',
    maxLength: 9,
    minLength: 6,
  },
  {
    countryCode: 'AO',
    countryName: 'Angola',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'UA',
    countryName: 'Ukraine',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'MA',
    countryName: 'Morocco',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'PL',
    countryName: 'Poland',
    maxLength: 9,
    minLength: 6,
  },
  {
    countryCode: 'UZ',
    countryName: 'Uzbekistan',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'MZ',
    countryName: 'Mozambique',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'MY',
    countryName: 'Malaysia',
    maxLength: 9,
    minLength: 7,
  },
  {
    countryCode: 'GH',
    countryName: 'Ghana',
    maxLength: 9,
    minLength: 5,
  },
  {
    countryCode: 'SA',
    countryName: 'Saudi Arabia',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'NP',
    countryName: 'Nepal',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'LK',
    countryName: 'Sri Lanka',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'TW',
    countryName: 'Taiwan',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'ZM',
    countryName: 'Zambia',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'CL',
    countryName: 'Chile',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'SN',
    countryName: 'Senegal',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'RO',
    countryName: 'Romania',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'NL',
    countryName: 'Netherlands',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'ZW',
    countryName: 'Zimbabwe',
    maxLength: 9,
    minLength: 5,
  },
  {
    countryCode: 'RW',
    countryName: 'Rwanda',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'BE',
    countryName: 'Belgium',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'JO',
    countryName: 'Jordan',
    maxLength: 9,
    minLength: 5,
  },
  {
    countryCode: 'AE',
    countryName: 'United Arab Emirates',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'TJ',
    countryName: 'Tajikistan',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'AZ',
    countryName: 'Azerbaijan',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'IL',
    countryName: 'Israel',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'HU',
    countryName: 'Hungary',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'LA',
    countryName: 'Laos',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'LY',
    countryName: 'Libya',
    maxLength: 9,
    minLength: 8,
  },
  {
    countryCode: 'KG',
    countryName: 'Kyrgyzstan',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'HK',
    countryName: 'Hong Kong',
    maxLength: 9,
    minLength: 4,
  },
  {
    countryCode: 'PY',
    countryName: 'Paraguay',
    maxLength: 9,
    minLength: 5,
  },
  {
    countryCode: 'BG',
    countryName: 'Bulgaria',
    maxLength: 9,
    minLength: 7,
  },
  {
    countryCode: 'SK',
    countryName: 'Slovakia',
    maxLength: 9,
    minLength: 4,
  },
  {
    countryCode: 'AL',
    countryName: 'Albania',
    maxLength: 9,
    minLength: 3,
  },
  {
    countryCode: 'IS',
    countryName: 'Iceland',
    maxLength: 9,
    minLength: 7,
  },
  {
    countryCode: 'GP',
    countryName: 'Guadeloupe',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'MQ',
    countryName: 'Martinique',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'GF',
    countryName: 'French Guiana',
    maxLength: 9,
    minLength: 9,
  },
  {
    countryCode: 'AD',
    countryName: 'Andorra',
    maxLength: 9,
    minLength: 6,
  },
  {
    countryCode: 'LI',
    countryName: 'Liechtenstein',
    maxLength: 9,
    minLength: 7,
  },
  {
    countryCode: 'MC',
    countryName: 'Monaco',
    maxLength: 9,
    minLength: 5,
  },
  {
    countryCode: 'CI',
    countryName: 'Ivory Coast',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'CM',
    countryName: 'Cameroon',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'NE',
    countryName: 'Niger',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'ML',
    countryName: 'Mali',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'BF',
    countryName: 'Burkina Faso',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'MW',
    countryName: 'Malawi',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'SO',
    countryName: 'Somalia',
    maxLength: 8,
    minLength: 5,
  },
  {
    countryCode: 'GT',
    countryName: 'Guatemala',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'EC',
    countryName: 'Ecuador',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'KH',
    countryName: 'Cambodia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'GN',
    countryName: 'Guinea',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'BJ',
    countryName: 'Benin',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'BI',
    countryName: 'Burundi',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'BO',
    countryName: 'Bolivia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'TN',
    countryName: 'Tunisia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'HT',
    countryName: 'Haiti',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'HN',
    countryName: 'Honduras',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'CU',
    countryName: 'Cuba',
    maxLength: 8,
    minLength: 6,
  },
  {
    countryCode: 'SL',
    countryName: 'Sierra Leone',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'TM',
    countryName: 'Turkmenistan',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'NI',
    countryName: 'Nicaragua',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'DK',
    countryName: 'Denmark',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'LB',
    countryName: 'Lebanon',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'LR',
    countryName: 'Liberia',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'CF',
    countryName: 'Central African Republic',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'OM',
    countryName: 'Oman',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'NO',
    countryName: 'Norway',
    maxLength: 8,
    minLength: 5,
  },
  {
    countryCode: 'CR',
    countryName: 'Costa Rica',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'KW',
    countryName: 'Kuwait',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'PA',
    countryName: 'Panama',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'GE',
    countryName: 'Georgia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'MN',
    countryName: 'Mongolia',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'BA',
    countryName: 'Bosnia and Herzegovina',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'MD',
    countryName: 'Moldova',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'AM',
    countryName: 'Armenia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'LT',
    countryName: 'Lithuania',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'BW',
    countryName: 'Botswana',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'LS',
    countryName: 'Lesotho',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'SI',
    countryName: 'Slovenia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'LV',
    countryName: 'Latvia',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'MK',
    countryName: 'North Macedonia',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'BH',
    countryName: 'Bahrain',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'SZ',
    countryName: 'Eswatini',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'BT',
    countryName: 'Bhutan',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'MO',
    countryName: 'Macau',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'MT',
    countryName: 'Malta',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'CW',
    countryName: 'Curacao',
    maxLength: 8,
    minLength: 7,
  },
  {
    countryCode: 'GI',
    countryName: 'Gibraltar',
    maxLength: 8,
    minLength: 8,
  },
  {
    countryCode: 'TD',
    countryName: 'Chad',
    maxLength: 7,
    minLength: 6,
  },
  {
    countryCode: 'TG',
    countryName: 'Togo',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'CG',
    countryName: 'Republic of the Congo',
    maxLength: 7,
    minLength: 6,
  },
  {
    countryCode: 'MR',
    countryName: 'Mauritania',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'ER',
    countryName: 'Eritrea',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'GM',
    countryName: 'Gambia',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'GA',
    countryName: 'Gabon',
    maxLength: 7,
    minLength: 6,
  },
  {
    countryCode: 'GW',
    countryName: 'Guinea-Bissau',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'TL',
    countryName: 'Timor-Leste',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'MU',
    countryName: 'Mauritius',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'FJ',
    countryName: 'Fiji',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'KM',
    countryName: 'Comoros',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'GY',
    countryName: 'Guyana',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'SR',
    countryName: 'Suriname',
    maxLength: 7,
    minLength: 6,
  },
  {
    countryCode: 'MV',
    countryName: 'Maldives',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'CV',
    countryName: 'Cape Verde',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'BN',
    countryName: 'Brunei',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'BZ',
    countryName: 'Belize',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'VU',
    countryName: 'Vanuatu',
    maxLength: 7,
    minLength: 5,
  },
  {
    countryCode: 'ST',
    countryName: 'Sao Tome and Principe',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'WS',
    countryName: 'Samoa',
    maxLength: 7,
    minLength: 3,
  },
  {
    countryCode: 'FM',
    countryName: 'Micronesia',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'AW',
    countryName: 'Aruba',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'TO',
    countryName: 'Tonga',
    maxLength: 7,
    minLength: 5,
  },
  {
    countryCode: 'MH',
    countryName: 'Marshall Islands',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'PW',
    countryName: 'Palau',
    maxLength: 7,
    minLength: 7,
  },
  {
    countryCode: 'NR',
    countryName: 'Nauru',
    maxLength: 7,
    minLength: 4,
  },
  {
    countryCode: 'GQ',
    countryName: 'Equatorial Guinea',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'DJ',
    countryName: 'Djibouti',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'NC',
    countryName: 'New Caledonia',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'PF',
    countryName: 'French Polynesia',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'SC',
    countryName: 'Seychelles',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'FO',
    countryName: 'Faroe Islands',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'GL',
    countryName: 'Greenland',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'WF',
    countryName: 'Wallis and Futuna',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'TV',
    countryName: 'Tuvalu',
    maxLength: 6,
    minLength: 5,
  },
  {
    countryCode: 'PM',
    countryName: 'Saint Pierre and Miquelon',
    maxLength: 6,
    minLength: 6,
  },
  {
    countryCode: 'SB',
    countryName: 'Solomon Islands',
    maxLength: 5,
    minLength: 5,
  },
  {
    countryCode: 'KI',
    countryName: 'Kiribati',
    maxLength: 5,
    minLength: 5,
  },
  {
    countryCode: 'CK',
    countryName: 'Cook Islands',
    maxLength: 5,
    minLength: 5,
  },
  {
    countryCode: 'FK',
    countryName: 'Falkland Islands',
    maxLength: 5,
    minLength: 5,
  },
  {
    countryCode: 'TK',
    countryName: 'Tokelau',
    maxLength: 4,
    minLength: 4,
  },
  {
    countryCode: 'NU',
    countryName: 'Niue',
    maxLength: 4,
    minLength: 4,
  },
];
